import $ from 'cash-dom';
import FormHandler from './form/FormHandler';

const partnerWithUsFormHandler = new FormHandler('#partner_with_us form', {
  'full_name': ['required', 'alpha', 'max|255'],
  'website': ['required', 'max|255'],
  'email': ['required', 'email'],
  'full_phone': ['required', 'phone'],
  'company': ['required', 'max|255'],
  'job_position': ['required', 'max|255'],
}, '#partner_with_us_form .unknown-error');

partnerWithUsFormHandler.onSuccessResponse((data) => {
  const $holder = $('#partner_with_us .form-holder');
  const $successMsg = $('#partner_with_us .success-msg');
  const el = $holder[0];

  const startHeight = el.offsetHeight;
  el.style.height = startHeight + 'px';

  // $('#partner_with_us_form').addClass('hidden');
  $successMsg.text(data?.message);
  $successMsg.removeClass('hidden');

  requestAnimationFrame(() => {
    const targetHeight = el.scrollHeight;
    el.style.height = targetHeight + 'px';
  });

  $('#partner_with_us form')[0].reset();
});

partnerWithUsFormHandler.mount();
